let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("3fI2Z")).then(() => parcelRequire('2Bz5k'));